import TimelinePanel from "./TimelinePanel";
import ComponentWrapper from "../../fragments/component-wrapper/ComponentWrapper";

export default function Timeline({ block, index }) {
  // console.log(block);
  if (!block) return null;

  const HeadingTag = index === 0 ? "h1" : "h2";

  return (
    <ComponentWrapper className="BlockTimeline" mode="light">
      <div className={"l-grid"}>
        <div className="l-grid__col l-grid__col--l-4-12">
          {block.heading && (
            <HeadingTag className={"h3"}>{block.heading}</HeadingTag>
          )}

          {block.description && <p>{block.description}</p>}
        </div>

        {block.items && (
          <div
            className={
              "BlockTimeline-items l-grid__col l-grid__col--l-5-12 l-grid__col--l-push-2-12"
            }
          >
            {block.items.map((item, index) => {
              const key = item.heading || index;
              if (block.iconType == "icon") {
                return (
                  <TimelinePanel item={item} icon={block.icon} key={key} />
                );
              }
              return <TimelinePanel item={item} index={index} key={key} />;
            })}
          </div>
        )}
      </div>
    </ComponentWrapper>
  );
}
